"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionServiceEventType = void 0;
var SessionServiceEventType;
(function (SessionServiceEventType) {
    SessionServiceEventType["SESSION_SERVICE_READY"] = "SessionServiceReady";
    SessionServiceEventType["SESSION_CREATED"] = "SessionCreated";
    SessionServiceEventType["SESSION_DESTROYED"] = "SessionDestroyed";
})(SessionServiceEventType = exports.SessionServiceEventType || (exports.SessionServiceEventType = {}));
